import React, { useState, useEffect, useRef } from 'react';
import './HomePage.css'; // 复用首页样式

// 随机数据生成器
const generateRandomSongs = (count, startIndex) => {
  const titles = ['星际迷航', '午后拿铁', '赛博朋克2077', '雨中漫步', '极光之恋', '未知的旅途', '心跳加速', '落日飞车'];
  const authors = ['AI 莫扎特', '虚拟歌姬', '未来节奏', '深蓝电脑', '云端歌手'];
  const colors = [
    ['#8EC5FC', '#E0C3FC'],
    ['#85FFBD', '#FFFB7D'],
    ['#FF9A9E', '#FECFEF'],
    ['#fa709a', '#fee140'],
    ['#4facfe', '#00f2fe'],
    ['#43e97b', '#38f9d7']
  ];

  return Array.from({ length: count }).map((_, i) => {
    const colorPair = colors[Math.floor(Math.random() * colors.length)];
    return {
      id: startIndex + i,
      title: titles[Math.floor(Math.random() * titles.length)] + ` #${startIndex + i}`,
      author: authors[Math.floor(Math.random() * authors.length)],
      bg: `linear-gradient(135deg, ${colorPair[0]} 0%, ${colorPair[1]} 100%)`,
      views: (Math.random() * 5 + 0.1).toFixed(1) + 'w'
    };
  });
};

const SectionListPage = ({ title, onBack, onItemClick }) => {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  // 初始化加载
  useEffect(() => {
    setSongs(generateRandomSongs(12, 1));
  }, []);

  // 处理滚动加载 (无限下滑)
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // 距离底部 50px 时加载更多
    if (scrollHeight - scrollTop - clientHeight < 50 && !loading) {
      setLoading(true);
      // 模拟网络请求延迟
      setTimeout(() => {
        setSongs(prev => [...prev, ...generateRandomSongs(6, prev.length + 1)]);
        setLoading(false);
      }, 500);
    }
  };

  return (
    // h-scrollable 阻止 App.jsx 的左右滑动手势
    <div className="section-list-page h-scrollable">
      <div className="section-list-header">
        <button className="icon-btn" onClick={onBack}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h3>{title}</h3>
        <div style={{ width: 32 }}></div> {/* 占位符保持标题居中 */}
      </div>

      <div 
        className="waterfall-container" 
        ref={scrollRef}
        onScroll={handleScroll}
      >
        <div className="waterfall-grid">
          {songs.map((song) => (
            <div key={song.id} className="waterfall-item" onClick={onItemClick}>
              <div className="wf-cover" style={{ background: song.bg }}>
                <div className="wf-play-icon"><i className="fas fa-play"></i></div>
                <div className="wf-views"><i className="fas fa-headphones"></i> {song.views}</div>
              </div>
              <div className="wf-info">
                <div className="wf-title">{song.title}</div>
                <div className="wf-author">{song.author}</div>
              </div>
            </div>
          ))}
        </div>
        
        {loading && (
          <div className="loading-indicator">
            <i className="fas fa-spinner fa-spin"></i> 加载更多灵感...
          </div>
        )}
        {/* 底部垫高，防止被导航栏遮挡 */}
        <div style={{ height: 80 }}></div>
      </div>
    </div>
  );
};

export default SectionListPage;